import { createAsyncThunk } from "@reduxjs/toolkit";
import { 
  getTableColumnNames, 
  GetAllTopics, 
  activeDeactiveTopics as activeDeactiveSubTopicsAPI, // Assuming a specific API or that the generic one can be used
  uploadImages,
  GetExaminationBoard,
  GetGrade,
  addTopicsAPI as addSubTopicAPI, // Assuming a specific API or that the generic one can be used
  GetAllSubTopics,
  activeDeactiveSubTopics,
  GetTopicsAPI,
  addSubTopicsAPI,
  updateSubTopicsAPI,
  deleteSubTopicsAPI, // This is correctly named for fetching all subtopics
} from "../../helpers/fakebackend_helper";
import { toast } from "react-toastify";
import { t } from "i18next";


// Fetch Topic Table Column Names
export const fetchSubTopicTableColumnNames = createAsyncThunk(
  "topics/fetchTopicTableColumnNames",
  async (params, thunkAPI) => { 
    try {
      const response = await getTableColumnNames(params); 
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

// Fetch All Sub Topics
export const fetchAllSubTopics = createAsyncThunk(
  "topics/fetchAllSubTopics",
  async (params, thunkAPI) => { 
    try {
      const response = await GetAllSubTopics(params);
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

// Add Topic
export const addSubTopic = createAsyncThunk(
  "subTopics/addSubTopic",
  async (subTopicData, thunkAPI) => {
    try {
      const response = await addSubTopicsAPI(subTopicData); 
      if (response.success) {
        toast.success(t(response.message) );
        return response.data;
      } 
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

// Update Topic
export const updateSubTopic = createAsyncThunk(
  "subTopics/updateSubTopic", 
  async (subTopicData, thunkAPI) => {
  try {
    const response = await updateSubTopicsAPI(subTopicData); 
    if (response.success) {
      toast.success(t(response.message) || "SubTopic updated successfully!");
      return response.data;
    }
  } catch (error) {
    return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
  }
});

// Delete Topics
export const deleteSubTopic = createAsyncThunk(
  "subTopics/deleteSubTopic", 
  async (subTopicIds, thunkAPI) => {
    try {
      const response = await deleteSubTopicsAPI(subTopicIds); 
      
        toast.success(t(response.message) || "SubTopic(s) deleted successfully!");
        return response.data; 
  
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

// Activate/Deactivate Topic
export const activateDeactivateSubTopic = createAsyncThunk(
  "subTopics/activateDeactivateSubTopic", 
  async (subTopicData, thunkAPI) => {
    try {
      const response = await activeDeactiveSubTopics(subTopicData); 
      if (response.success) {
        toast.success(t(response.message));
        return response.data; 
      } 
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

// Upload Topic Image Icon
export const uploadSubTopicImageIcon = createAsyncThunk(
  "subTopics/uploadSubTopicImageIcon", // Changed action type
  async (imageData, thunkAPI) => {
  try {
    const response = await uploadImages(imageData);
    if (response.IsSuccess) {
      return response.Data; 
    } 
  } catch (error) {
    console.log("error",error);
    return thunkAPI.rejectWithValue(error.response?.data || "Something went wrong");
  }
});